export enum EUnitOfMeasure {
  OSOBA = 1,
  NOC,
  OSOBA_NOC,
  OSOBA_TJEDAN,
  REZERVACIJA,
  TJEDAN,
  PO_SATU,
}
